var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LazyLoader extends Component {
    constructor() {
        super('LazyLoader', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            LazyLoader.refreshImageList();
            $(window).on('scroll', () => {
                LazyLoader.checkImageVisibility();
            });
            this.success();
        });
    }
    static checkImageVisibility() {
        LazyLoader.images.each((image) => __awaiter(this, void 0, void 0, function* () {
            if (image.viewportPosition().y < $(window).height() + LazyLoader.tolerence && image.data('backgroundLoaded') != 'true') {
                const imageURL = this.get_src(image.data('hwSrc'));
                yield this.preloadImage(imageURL);
                image.attr('src', imageURL);
                image.data('backgroundLoaded', 'true');
            }
        }));
        LazyLoader.backgroundImages.each((image) => __awaiter(this, void 0, void 0, function* () {
            if (image.viewportPosition().y < $(window).height() + LazyLoader.tolerence && image.data('backgroundLoaded') != 'true') {
                const imageURL = this.get_src(image.data('hwBackgroundImage'));
                yield this.preloadImage(imageURL);
                image.css('background-image', `url('${imageURL}')`);
                image.data('backgroundLoaded', 'true');
            }
        }));
    }
    static refreshImageList() {
        LazyLoader.images = $('*[data-hw-src]');
        LazyLoader.backgroundImages = $('*[data-hw-background-image]');
        LazyLoader.checkImageVisibility();
    }
    static get_src(image_data) {
        const srcs = image_data.split(';');
        return devicePixelRatio > 1 && srcs[1] ? srcs[1] : srcs[0];
    }
    static preloadImage(image_data) {
        return __awaiter(this, void 0, void 0, function* () {
            const img = new Image();
            img.src = this.get_src(image_data);
            return new Promise((resolve) => {
                img.onload = () => {
                    resolve();
                };
                img.onerror = () => {
                    resolve();
                };
            });
        });
    }
}
LazyLoader.tolerence = 100;
